import { render, staticRenderFns } from "./GetTriggers.vue?vue&type=template&id=481f4288"
import script from "./GetTriggers.vue?vue&type=script&lang=js"
export * from "./GetTriggers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports